export default __webpack_public_path__ + "static/media/app7-quotes.2dbcc067.png";